// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".link-button[data-v-01905bcc] {\n  background: #00427e;\n  border: none;\n  border-radius: 3px;\n  padding: 14px 25px;\n  color: white;\n  cursor: pointer;\n}\n.button-close[data-v-01905bcc] {\n  background: white;\n  color: #00427e;\n  border: none;\n  border: 1px solid #00427e;\n  padding: 13px 30px;\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
